// extracted by mini-css-extract-plugin
module.exports = {"overlay":"theme__overlay--2LA9x","active":"theme__active--1mb5R"};